module.exports = {
    recharge: {
        rechargeTitle: '流量充值',
        loading: '加载中...',
        did: 'DID',
        symbol: '￥',
        total: '合计',
        expire: '到期',
        unpaid: '未支付',
        historicalOrders: '历史订单',
        noOrders: '暂无订单',
        orderNo: '订单编号',
        buyTime: '下单时间',
        endTime: '到期时间',
        disbursements: '实付款',
        cancelOrder: '取消订单',
        pay: '支付',
        haveDoubts: '对订单有疑问？',
        renew: '立即续费',
        cardNumTips: '卡号位置如图所示',
        cardNumOrIccid: '请输入4G卡号或ICCID',
        query: '查 询',
        tips: '温馨提示',
        tips4G1: '1.ICCID号只输入前19位，推荐通过扫描获取。',
        tips4G11: '1.ICCID号只输入前20位，推荐通过扫描获取。',
        tips4G2: '2.仅支持当前平台订购流量套餐，其他充值渠道无效。',
        tips4G3: '3.SIM卡不能在手机或其他移动设备使用，一经发现将立即停卡。',
        msgTips: '请输入有效的ICCID',

    }
}

